import React from 'react';
import { Control } from 'react-hook-form';
import { FormTextarea } from '../components/shared/FormTextarea';
import { FormInput } from '../components/shared/FormInput';
import { OnboardingData } from '../types';

interface Step5BusinessGoalsProps {
  control: Control<OnboardingData>;
}

const Step5BusinessGoals: React.FC<Step5BusinessGoalsProps> = ({ control }) => {
  return (
    <div className="space-y-3">
      {/* Question 1: Business model */}
      <div>
        <FormTextarea
          name="step5_businessGoals.businessModel"
          control={control}
          label="Describe your business model."
          placeholder=""
          rows={2}
          rules={{ required: 'This field is required' }}
        />
      </div>

      {/* Question 2: Budget */}
      <div>
        <FormInput
          name="step5_businessGoals.budget"
          control={control}
          label="What is your budget? Marketing and SEO."
          placeholder=""
          rules={{ required: 'This field is required' }}
        />
      </div>

      {/* Question 3: Ongoing marketing */}
      <div>
        <FormTextarea
          name="step5_businessGoals.ongoingMarketing"
          control={control}
          label="Are there any other marketing efforts going on?"
          placeholder=""
          rows={2}
          rules={{ required: 'This field is required' }}
        />
      </div>

      {/* Question 4: PR agency */}
      <div>
        <FormInput
          name="step5_businessGoals.prAgency"
          control={control}
          label="Are you working with a PR agency?"
          placeholder=""
          rules={{ required: 'This field is required' }}
        />
      </div>

      {/* Question 5: Goals */}
      <div className="space-y-4">
        <label className="block text-sm text-text font-medium">
          Where are you now? Where do you want to be in 1 year, 3 years, 5 years?
        </label>

        <FormTextarea
          name="step5_businessGoals.whereAreYouNow"
          control={control}
          label=""
          placeholder="Where are you now"
          rows={2}
        />

        <div className="flex flex-col gap-4">
          <div className="space-y-2">
            <label className="block text-sm text-text font-medium">1 year</label>
            <FormTextarea
              name="step5_businessGoals.goals1Year"
              control={control}
              label=""
              placeholder="Where do you want to be"
              rows={2}
              rules={{ required: 'This field is required' }}
            />
          </div>

          <div className="space-y-2">
            <label className="block text-sm text-text font-medium">3 year</label>
            <FormTextarea
              name="step5_businessGoals.goals3Years"
              control={control}
              label=""
              placeholder="Where do you want to be"
              rows={2}
              rules={{ required: 'This field is required' }}
            />
          </div>

          <div className="space-y-2">
            <label className="block text-sm text-text font-medium">5 year</label>
            <FormTextarea
              name="step5_businessGoals.goals5Years"
              control={control}
              label=""
              placeholder="Where do you want to be"
              rows={2}
              rules={{ required: 'This field is required' }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export { Step5BusinessGoals };
